import getApiClient from '@/plugins/api-client'
import { parseFilters } from '@/util/helpers'

export default {
  loadEvents: function () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
      ...this.filters,
      ...this.pagination.getParams(),
    })

    api.get('traffic_light_events', { params })
      .then(result => {
        this.events = result.data['hydra:member']
        this.pagination.updateData(result.data)
      })
      .catch(error => {
        this.error = error
      })
  },

  clearFilters () {
    this.filters = {}
    this.loadEvents()
  },

  translateEventType (type) {
    let result

    switch (type) {
      case 'missed_class':
        result = 'Faltou à aula confirmada'
        break
      case 'not_answered_class':
        result = 'Não aceitou aula'
        break
      case 'canceled_class':
        result = 'Cancelou aula após confirmar'
    }

    return result
  },

  translateStatusName (statusName) {
    let result

    switch (statusName) {
      case 'red':
        result = 'VERMELHO'
        break
      case 'yellow':
        result = 'AMARELO'
        break
      case 'green':
        result = 'VERDE'
    }

    return result
  },
}
